import { Spinner } from '@frontend/components/common';
import { IdentificationClient } from '@frontend/identification/api';
import { CommonMessage } from '@frontend/lang';
import { ToastUtil } from '@frontend/toast-utils';
import { FormattedMessage } from 'react-intl';

import { DeleteModal } from '../../../../modal/delete-modal/delete-modal.component';
import { DefaultContainer } from '../../../../modal/detail-modal/default-container/default-container';
import { BadgeCreate } from '../badge-create/badge-create.component';
import { BadgeUpdate } from '../badge-update/badge-update.component';
import { useBadgeCard } from './badge-card.controller';

export interface BadgeCardProps {
    entity_id: string;
}
export const BadgeCard = (props: BadgeCardProps) => {
    const viewProps = useBadgeCard(props);
    return (
        <DefaultContainer
            title={CommonMessage.OBJECTS.IDENTIFICATION.BADGE}
            content={
                viewProps.isLoading && !viewProps.badge ? (
                    <Spinner />
                ) : !viewProps.badge ? (
                    <div className='text-foreground-muted text-base'>{CommonMessage.ERRORS.NO_BADGE}</div>
                ) : (
                    <div className='inline-flex flex-col items-start justify-start gap-4 self-stretch'>
                        <div className='flex flex-col items-start justify-start gap-0.75'>
                            <div className='text-brand-muted justify-start text-base font-medium'>{CommonMessage.OBJECTS.BADGE.NUMBER}</div>
                            <div className='text-foreground-default w-52 justify-start text-base font-medium'>{viewProps.badge?.key}</div>
                        </div>
                    </div>
                )
            }
            update={{
                onUpdate: () =>
                    viewProps.badge
                        ? viewProps.openModal(viewProps.updateBadgeId, () => (
                              <BadgeUpdate
                                  badge={viewProps.badge!}
                                  onSubmitSuccess={viewProps.setBadge}
                              />
                          ))
                        : viewProps.openModal(viewProps.createBadgeId, () => (
                              <BadgeCreate
                                  entity_id={props.entity_id}
                                  onSubmitSuccess={viewProps.setBadge}
                              />
                          ))
            }}
            {...(viewProps.badge && {
                delete: {
                    onDelete: () =>
                        viewProps.openModal(viewProps.deleteBadgeId, () => (
                            <DeleteModal
                                func={() => IdentificationClient.deleteIdentification(viewProps.badge!.account_id, viewProps.badge!.id)}
                                title={viewProps.badge!.key}
                                description={
                                    <FormattedMessage
                                        id='user.security.badge.deleteDescription'
                                        description='Description for deleting badge modal'
                                        defaultMessage='Are you sure you want to delete this badge? This action cannot be undone.'
                                    />
                                }
                                callback={() => viewProps.setBadge(null)}
                                onDeleteSuccess={() => ToastUtil.success(CommonMessage.TOAST.DELETE.SUCCESS(viewProps.badge!.key))}
                                entityName={viewProps.badge!.key}
                            />
                        ))
                }
            })}
        />
    );
};
